/**
 * @description Common Store Module
 * @author Fahid Mohammad
 */
import Vue from 'vue';
import http from '../../util/axios';
import i18n from '../../i18n';
import config from '../../config';

export default {
    namespaced: true,
    state: {        
        activeChatroom: null
    },
    mutations: {        
        SET_ACTIVE_CHATROOM: (state, payload) => {
            state.activeChatroom = payload
        }
    },
    actions: {
        
        CREATE_ROOM({ commit }, payload) {
            return new Promise((resolve, reject) => {
                return http.post( config.SOCKETHUB_ENDPOINT +'/socket/createRoom', payload)
                .then(({ status, data, message }) => {
                    if( status==1000 ) {
                        commit('SET_ACTIVE_CHATROOM', payload.roomName);
                        resolve(data)
                    }
                    reject({message})
                })
                .catch( err => {
                    reject( err )
                })
            })
        },
        GET_CHAT_MESSAGES({ commit }, chatroom_id) {
            return new Promise((resolve, reject) => {
                return http.post( config.SOCKETHUB_ENDPOINT +'/chat/get_message', { chatroom_id })
                    .then(({ status, data, message }) => {
                        if( status==1000 ) {
                            commit('SET_ACTIVE_CHATROOM', chatroom_id);
                            resolve(data)
                        }
                        reject({message})
                    })
                    .catch( err => {
                        reject( err )
                    })
            })
        },
        SEND_CHAT_MESSAGE({ commit }, payload) {
            return new Promise(( resolve, reject ) => {
                return http.post( `${config.SOCKETHUB_ENDPOINT}/chat/message`, payload )
                    .then(({ status, message }) => {
                        if( status==1000 ) {
                            resolve(status)
                        }
                        reject( {message} )
                    })
                    .catch( err => {
                        reject( err )
                    })
            })
        },
        SET_ACTIVE_CHATROOM({ commit }, payload) {
            commit('SET_ACTIVE_CHATROOM', payload);
        },
        SEND_CHAT_MESSAGE_OPERATION({ commit }, payload) {
            return new Promise(( resolve, reject ) => {
                return http.post( `${config.OPERATION_HUB_ENDPOINT}/sta/chat`, payload )
                    .then(({ status, message }) => {
                        if( status==1000 ) {
                            resolve(status)
                        }
                        reject( {message} )
                    })
                    .catch( err => {
                        reject( err )
                    })
            })
        },        
        GET_CHAT_MESSAGES_BUPA({ commit }, chatroom_id) {
            return new Promise((resolve, reject) => {
                return http.post( config.SOCKETHUB_ENDPOINT +'/chat/get_message', { chatroom_id })
                    .then(({ status, data, message }) => {
                        if( status==1000 ) {
                            commit('SET_ACTIVE_CHATROOM', chatroom_id);
                            resolve(data)
                        }
                        reject({message})
                    })
                    .catch( err => {
                        reject( err )
                    })
            })
        },
        SEND_CHAT_MESSAGE_BUPA({ commit }, payload) {
            return new Promise(( resolve, reject ) => {
                return http.post( `${config.SOCKETHUB_ENDPOINT}/chat/message`, payload )
                    .then(({ status, message }) => {
                        if( status==1000 ) {
                            resolve(status)
                        }
                        reject( {message} )
                    })
                    .catch( err => {
                        reject( err )
                    })
            })
        },
    },
    getters: {        
        getActiveChatroom: state => state.activeChatroom,
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/appointments.js